import { c as _c } from "react/compiler-runtime";
// Разделы кабинета, которых нет в кадрах макета «Профиль», но функциональность
// которых нельзя терять: Баланс (кошелёк для чекаута), Адреса, Устройства.
// Открываются ссылками из «Способов оплаты» и «Личных данных».
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "@/api";
import { ProfilePanel } from "@/components/profile/profile-shell";
import { useProfile } from "@/store";
import { AddressesPanel, BalancePanel, SessionsPanel } from "./legacy-panels";

// Прежние панели рисуют собственный заголовок с подсказкой; в кабинете его
// заменяют крошки ProfilePanel, поэтому шапку панели прячем.
const HIDE_LEGACY_HEADER = "[&>section>div:first-child]:hidden";
export function ProfileBalancePage() {
  const $ = _c(15);
  const userId = useProfile(_temp);
  const qc = useQueryClient();
  let t0;
  if ($[0] !== userId) {
    t0 = {
      queryKey: ["buyer", userId, "balance"],
      queryFn: _temp2
    };
    $[0] = userId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const balance = useQuery(t0);
  let t1;
  if ($[2] !== userId) {
    t1 = {
      queryKey: ["buyer", userId, "ledger"],
      queryFn: _temp3
    };
    $[2] = userId;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const ledger = useQuery(t1);
  let t2;
  if ($[4] !== qc || $[5] !== userId) {
    t2 = async () => {
      await qc.invalidateQueries({
        queryKey: ["buyer", userId]
      });
    };
    $[4] = qc;
    $[5] = userId;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const reload = t2;
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [{
      label: "\u0421\u043F\u043E\u0441\u043E\u0431\u044B \u043E\u043F\u043B\u0430\u0442\u044B",
      to: "/profile/payments"
    }, {
      label: "\u0411\u0430\u043B\u0430\u043D\u0441"
    }];
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = balance.data ?? null;
  let t5;
  if ($[8] !== ledger.data) {
    t5 = ledger.data ?? [];
    $[8] = ledger.data;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== balance.isPending || $[11] !== reload || $[12] !== t4 || $[13] !== t5) {
    t6 = <ProfilePanel crumbs={t3}><div className={HIDE_LEGACY_HEADER}><BalancePanel balance={t4} ledger={t5} onChanged={reload} loading={balance.isPending} /></div></ProfilePanel>;
    $[10] = balance.isPending;
    $[11] = reload;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}
function _temp3() {
  return api.buyer.listLedger();
}
function _temp2() {
  return api.buyer.getBalance();
}
function _temp(s) {
  return s.user?.id ?? "guest";
}
export function ProfileAddressesPage() {
  const $ = _c(16);
  const user = useProfile(_temp4);
  const profile = useProfile(_temp5);
  const qc = useQueryClient();
  const userId = user?.id ?? "guest";
  let t0;
  if ($[0] !== userId) {
    t0 = {
      queryKey: ["buyer", userId, "addresses"],
      queryFn: _temp6
    };
    $[0] = userId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const addresses = useQuery(t0);
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [{
      label: "\u041B\u0438\u0447\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435",
      to: "/profile/personal"
    }, {
      label: "\u0410\u0434\u0440\u0435\u0441\u0430"
    }];
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== addresses.data) {
    t2 = addresses.data ?? [];
    $[3] = addresses.data;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = profile?.name || user?.phone || "";
  const t4 = user?.phone ?? "";
  let t5;
  if ($[5] !== t3 || $[6] !== t4) {
    t5 = {
      recipient: t3,
      phone: t4
    };
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== qc || $[9] !== userId) {
    t6 = async () => {
      await qc.invalidateQueries({
        queryKey: ["buyer", userId, "addresses"]
      });
    };
    $[8] = qc;
    $[9] = userId;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== addresses.isPending || $[12] !== t2 || $[13] !== t5 || $[14] !== t6) {
    t7 = <ProfilePanel crumbs={t1}><div className={HIDE_LEGACY_HEADER}><AddressesPanel addresses={t2} contact={t5} onChanged={t6} loading={addresses.isPending} /></div></ProfilePanel>;
    $[11] = addresses.isPending;
    $[12] = t2;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}
function _temp6() {
  return api.buyer.listAddresses();
}
function _temp5(s_0) {
  return s_0.profile;
}
function _temp4(s) {
  return s.user;
}
export function ProfileDevicesPage() {
  const $ = _c(12);
  const userId = useProfile(_temp7);
  const qc = useQueryClient();
  let t0;
  if ($[0] !== userId) {
    t0 = {
      queryKey: ["buyer", userId, "sessions"],
      queryFn: _temp8
    };
    $[0] = userId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const sessions = useQuery(t0);
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [{
      label: "\u041B\u0438\u0447\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435",
      to: "/profile/personal"
    }, {
      label: "\u0423\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0430"
    }];
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== sessions.data) {
    t2 = sessions.data ?? [];
    $[3] = sessions.data;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== qc || $[6] !== userId) {
    t3 = async () => {
      await qc.invalidateQueries({
        queryKey: ["buyer", userId, "sessions"]
      });
    };
    $[5] = qc;
    $[6] = userId;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== sessions.isPending || $[9] !== t2 || $[10] !== t3) {
    t4 = <ProfilePanel crumbs={t1}><div className={HIDE_LEGACY_HEADER}><SessionsPanel sessions={t2} onChanged={t3} loading={sessions.isPending} /></div></ProfilePanel>;
    $[8] = sessions.isPending;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}
function _temp8() {
  return api.buyer.listSessions();
}
function _temp7(s) {
  return s.user?.id ?? "guest";
}